import { useMediaQuery } from 'react-responsive';

export const useBreakpoint = () => {
  const isExtraSmall = useMediaQuery({ query: '(max-width: 575px)' }); // sm
  const isSmall = useMediaQuery({
    query: '(min-width: 576px) and (max-width: 767px)',
  }); // md
  const isMedium = useMediaQuery({
    query: '(min-width: 768px) and (max-width: 991px)',
  }); // lg
  const isLarge = useMediaQuery({
    query: '(min-width: 992px) and (max-width: 1199px)',
  }); // xl
  const isExtraLarge = useMediaQuery({ query: '(min-width: 1200px)' }); // Above xl

  return { isExtraSmall, isSmall, isMedium, isLarge, isExtraLarge };
};
